module.exports = __webpack_public_path__ + "static/logo_dark-b17d9540fcc62a15b3f9f76d107c9222.png";